<template>
<div id="teaserInfo">
  <div class="container is-fluid  text-center">
    <div class="wrapper">
      <div class="columns is-fullheight">
        <div class="column">
          <h1>March 15–17, 2019</h1>
          <h1>NRW-Forum Düsseldorf</h1>
        </div>
        <div class="column">
          <h1>Meta Marathon 2019</h1>
          <h1>Robotics</h1>
        </div>
      </div>
      <div class="columns is-fullheight">
        <div class="column align-bottom">
          <h1><a href="http://www.google.com" target="_blank">Tickets</a></h1>
        </div>
        <div class="column align-bottom">
          <h1><a href="http://www.google.com" target="_blank">2018 Recap</a></h1>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import anime from 'animejs'

export default {
  data() {
    return {
      name: 'teaserInfo',
      animation: null,
      delay: 5750,
      delayOffset: 150,
      parentLoaded: false,
    }
  },
  methods: {
    initAnimation() {

      var self = this;
      this.animation = anime({
        targets: 'h1',
        translateY: [75, 0],
        // translateZ: {
        //   value: [800, 0],
        //   elasticity: 250,
        //   // easing: 'easeInOutSine',
        //   duration: 1000
        // },
        opacity: {
          value: [0, 1],
          easing: 'easeInQuad',
          duration: 1000
        },
        autoplay: false,
        duration: 3000,
        delay: function(target, index) {
          return self.delay + index * self.delayOffset;
        },
        elasticity: 150
      });

    },
    playAnimation() {

      //  this.animation.play;
    }
  },
  mounted() {
    this.initAnimation();
    document.getElementsByTagName('a')[0].addEventListener('touchstart', event => {
      event.stopPropagation();
    });
    document.getElementsByTagName('a')[1].addEventListener('touchstart', event => {
      event.stopPropagation();
    });
  },
  watch: {
    parentLoaded(value) {
      if (value) {
        this.animation.play();
      } else {
        this.animation.pause();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#teaserInfo {
    perspective: 800px;
    padding: 2em 0;
    position: fixed;
    z-index: 2;
    margin: 0;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    color: white;
    transform: translateZ(0);
    mix-blend-mode: difference;
    //perspective-origin: 50% 50%;
}

.column {
    margin: 0;
    padding: 0;
}
.container {
    margin: 0;
}
.is-fullheight.columns {
    height: calc(50vh - 2em);
    margin: 0;
}

.align-bottom {
    margin-top: auto;
}

h1,
h2 {
    font-size: 3.5em;
    font-weight: 300;
    margin: 0;
    letter-spacing: -1px;
    line-height: 1;
}

.text-center {
    text-align: center;
}

a {
    color: white;
    padding: 0.2em 0;
    display: inline-block;
    transition: all 0.15s ease;
    border: 3px solid transparent;
}

a:hover {
    color: white;
    padding: 0.2em 0.4em;
    border-bottom: 3px solid white;
    transform: translateY(0.1em);
}

@media screen and (max-width: 768px) {
    h1,
    h2 {
        font-size: 1.8em;
    }
    .is-fullheight.columns {
        height: calc(85vh - 2em);
        margin: 0;
    }
    #teaserInfo {
        mix-blend-mode: initial;
    }
    a {
        padding: 0;
        border: none;
    }
    a:hover {
        padding: 0;
        border-bottom: 0 solid white;
        border: none;
    }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
    h1,
    h2 {
        font-size: 2.5em;
    }
    #teaserInfo {
        mix-blend-mode: initial;
    }
    a {
        padding: 0;
        border: none;
    }

    a:hover {
        padding: 0;
        border-bottom: 0 solid white;
        border: none;
    }
}
@media screen and (min-width: 1024px) and (max-width: 1280px) {
    h1,
    h2 {
        font-size: 3em;
    }
}

@media screen and (max-width: 768px) and (orientation: landscape) {
    h1,
    h2 {
        font-size: 2em;
    }
    .is-fullheight.columns {
        height: calc(75vh - 2em);
        margin: 0;
    }

    #teaserInfo {
        mix-blend-mode: initial;
    }
    a {
        padding: 0;
        border: none;
    }

    a:hover {
        padding: 0;
        border-bottom: 0 solid white;
        border: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/teaserInfo.vue